import DefaultComponent from "./components/DefaultComponent";

import Home from "./pages/Home";
import Calculator from "./pages/Calculator";
import History from "./pages/History";
import Settings from "./pages/Settings";
import About from "./pages/About";
import Legal from "./pages/Legal";
import NotFound from "./pages/404";

export default [
    ...applyRules(['guest'], [
        { path: '', component: DefaultComponent, redirect: { name: 'Home' }, children:
            [
                { path: '/', name: 'Home', component: Home, meta: { title: 'Inicio' } },
                { path: '/calculator', name: 'Calculator', component: Calculator, meta: { title: 'Calculadora' } },
                { path: '/history', name: 'History', component: History, meta: { title: 'Historial' } },
                { path: '/settings', name: 'Settings', component: Settings, meta: { title: 'Configuración' } },
                { path: '/about', name: 'About', component: About, meta: { title: 'Información' } },
                { path: '/legal/:id', name: 'Legal', component: Legal, meta: { title: 'Información Legal' } },
            ]
        },
    ]),
    ...applyRules(['auth'], [

    ]),
    { path: '/m', redirect: { name: 'Home' }, meta: { title: 'Inicio' } },
    { path: '*', component: NotFound, meta: { title: 'Página no Encontrada' } }
];

function applyRules(rules, routes) {
    for (let i in routes) {
        routes[i].meta = routes[i].meta || {};

        if (!routes[i].meta.rules) {
            routes[i].meta.rules = [];
        }
        routes[i].meta.rules.unshift(...rules);

        if (routes[i].children) {
            routes[i].children = applyRules(rules, routes[i].children);
        }
    }

    return routes
}
